<template>
  <div>
    <div
      v-if="!showfirstCTA"
      :style="{ background: initialdata.bgColor || defaultBgColor }"
      style="padding: 5rem 0"
    >
      <div class="augmented-slider-title" v-html="initialdata.heading"></div>
      <div class="augmented-slider-subheading" v-html="initialdata.subheading"></div>
      <div class="augmented-slider">
        <div v-for="(slide, index) in initialdata.slide" :key="index" class="slide">
          <img :src="slide.imageSrc" :alt="slide.imageAlt" />
          <div v-if="slide.title" class="title">{{ slide.title }}</div>
          <div v-if="slide.description" class="description">{{ slide.description }}</div>
        </div>
      </div>
      <div v-if="initialdata.isctaenabled" class="slider-cta-button-block">
        <button class="augmented-slider-cta" @click="showCTA()">{{ initialdata.ctatext }}</button>
      </div>
    </div>
    <div v-else class="mctb_popup_03_ mctb-modal-mask" style="background-color: rgb(0 0 0 / 6%)">
      <div class="mctb_popup_04_ mctb-modal-wrapper">
        <div
          class="mctb_popup_05_ mctb-modal-container"
          style="box-shadow: 0 2px 8px rgb(0 0 0 / 5%)"
        >
          <div
            class="mctb_popup_06_ mctb-carousel-mode-header"
            :style="screenHeight"
            style="padding: 0"
          >
            <div
              v-for="(product, index) in initialdata.popinitem"
              :key="index"
              :style="{ background: product.bgColor }"
            >
              <div v-if="index == 0" class="close-icon-new" @click="showCTA()"></div>
              <div class="text-content" :style="{ margin: index == 0 ? '1rem 1rem' : '' }">
                <div
                  class="heading"
                  :style="{ color: product.headingColor }"
                  v-html="product.heading"
                ></div>
                <div class="subheading" v-html="product.subheading"></div>
              </div>
              <img :src="product.imageSrc" :alt="product.imageAlt" />
              <div
                class="augmented-description"
                :style="{
                  margin: index == 0 && initialdata.popinitem.length > 1 ? '1rem 1rem' : '',
                }"
                v-html="product.description"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'augmented-slider',
  props: {
    initialdata: {
      type: Object,
    },
  },
  data() {
    return {
      showfirstCTA: false,
      defaultBgColor: 'linear-gradient(180deg, #F9F9F9 0%, rgba(255, 255, 255, 0) 100%)',
    };
  },
  computed: {
    screenHeight() {
      return {
        height: window.innerHeight + 15 + 'px',
      };
    },
  },
  methods: {
    showCTA() {
      this.showfirstCTA = !this.showfirstCTA;
    },
  },
};
</script>
